import { render, staticRenderFns } from "./element-select-list.vue?vue&type=template&id=65a4f47a&scoped=true"
import script from "./element-select-list.vue?vue&type=script&lang=js"
export * from "./element-select-list.vue?vue&type=script&lang=js"
import style0 from "./element-select-list.vue?vue&type=style&index=0&id=65a4f47a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4f47a",
  null
  
)

export default component.exports